import React from "react";
import { Row as RSRow, Col as RSCol } from "reactstrap";
import classNames from "classnames";

import style from "./Customstrap.scss";

export const Row = (props) => {
  const { className, ...otherProps } = props;
  const newClassName = classNames(className, style.row);

  return <RSRow className={newClassName} {...otherProps} />;
};

export const Col = (props) => {
  const { className, ...otherProps } = props;
  const newClassName = classNames(className, style.col);
  return <RSCol className={newClassName} {...otherProps} />;
};
